import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.css";
import "./app.scss";
import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.3.0";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import App from "./App";
import { Web3ReactProvider } from "@web3-react/core";
import {
  hooks as walletConnectV2Hooks,
  walletConnectV2,
} from "./connectors/walletConnectV2.js";
import { hooks as metaMaskHooks, metaMask } from "./connectors/metaMask";
import { getLibrary } from "hooks/useLibrary";

const connectors = [
  [walletConnectV2, walletConnectV2Hooks],
  [metaMask, metaMaskHooks],
];

ReactDOM.render(
  <Web3ReactProvider connectors={connectors} getLibrary={getLibrary}>
    <App />
  </Web3ReactProvider>,

  document.getElementById("root")
);
